<div
  class="tabs-wrapper"
  [class.sticky]="sticky()"
  [class.embedded]="embedded()"
>
  @if (leftContainer()) {
    <div class="left-container">
      <ng-container [ngTemplateOutlet]="leftContainer()"></ng-container>
    </div>
  }
  <ul #tabsList [class.autowidth]="autowidth()">
    <span
      class="indicator"
      [style.left.px]="indicatorLeft()"
      [style.width.px]="indicatorWidth()"
    ></span>
    @for (tab of tabsSignal(); track tab) {
      <li
        (click)="selectTab(tab)"
        [class.small]="size() === TabsSize.SMALL"
        [class.medium]="size() === TabsSize.MEDIUM"
        [class.large]="size() === TabsSize.LARGE"
        [class.active]="tab.active()"
        #tabItem
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            {{ tab.label() }}
            @if (tab.tag(); as tag) {
              <ct-lib-tag [variant]="tag.type" class="ms-2">{{
                tag.label
              }}</ct-lib-tag>
            }
          </div>
          @if (tab.labelCounter() !== null) {
            <ct-lib-tag [variant]="TagVariant.COUNTER_DEFAULT" class="ms-2">{{
              tab.labelCounter()
            }}</ct-lib-tag>
          }
        </div>
      </li>
    }
  </ul>
  @if (rightContainer()) {
    <div class="right-container">
      <ng-container [ngTemplateOutlet]="rightContainer()"></ng-container>
    </div>
  }
</div>
<div class="d-flex flex-fill flex-column">
  @if (animateHeight()) {
    <app-animated-height-container [maxHeight]="false" [hideOverflow]="true">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </app-animated-height-container>
  } @else {
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  }
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</div>
